import type {
  IAuthenticationService,
  ITokenService,
  IUserStorageService,
} from "@/application/ports/services";
import type { ILogger } from "@/application/ports/ILogger";
import type { IMonitoring } from "@/application/ports/IMonitoring";
import { getUserErrorMessage } from "@/application/errors/ApiClientError";
import { clearAuthData } from "@/application/services/authUtils";

export class LogoutUseCase {
  private authService: IAuthenticationService;
  private tokenService: ITokenService;
  private userStorageService: IUserStorageService;
  private logger: ILogger;
  private monitoring: IMonitoring;

  constructor(
    authService: IAuthenticationService,
    tokenService: ITokenService,
    userStorageService: IUserStorageService,
    logger: ILogger,
    monitoring: IMonitoring,
  ) {
    this.authService = authService;
    this.tokenService = tokenService;
    this.userStorageService = userStorageService;
    this.logger = logger;
    this.monitoring = monitoring;
  }

  async execute(): Promise<{ success: boolean; error?: string }> {
    try {
      await this.authService.logout();
      return { success: true };
    } catch (error) {
      this.logger.error("Logout service failed:", error);
      return {
        success: false,
        error: getUserErrorMessage(error, "Logout failed"),
      };
    } finally {
      clearAuthData(this.tokenService, this.userStorageService, this.monitoring);
    }
  }
}
